import { render, staticRenderFns } from "./ShippingPopover.vue?vue&type=template&id=24dae5fc"
import script from "./ShippingPopover.vue?vue&type=script&lang=ts"
export * from "./ShippingPopover.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports